/* eslint-disable no-loss-of-precision */
/* eslint-disable no-unused-vars */
/* eslint-disable indent */

import React, { useState, useEffect, useRef } from "react";
import {
  Form,
  Row,
  Col,
  Spin,
  Button,
  Card,
  message,
  notification,
  Input,
  Select,
} from "antd";
import { capitalize, firstLetterCapsInSentence } from "../../../../utils";
import UploadDocument from "../../CrediteBooking/UploadDocument";
import Heading from "../../../../components/Heading";
import EwayBillDrawer from "../../CrediteBooking/EwayBillDrawer/EwayBillDrawer";
import ChildDrawer from "../../CrediteBooking/childDrawer";
import RecentBooking from "../../CrediteBooking/RecentBooking";
import RetailReturnAddressDrawer from "./RetailReturnDrawer";
import API from "../../../../api";
import urls from "../../../../api/urls";
import NewRetailForm from "./NewRetailForm";

import AddressCard from "./AddressCard";
import useClientAndDepartment from "../../CrediteBooking/useClientAndDepartment ";
import moment from "moment";

import { sendSms, sendWhatApp } from "./WhatsAppNSms";
import { focusFirstInputAndScrollToTop } from "../../../../components/CustomFunctions";

import "./style.scss";
import axios from "axios";
import { getToken } from "../../../../utils/worker";
import { useLocation, useParams } from "react-router-dom";
import useCustomNavigate from "../../../../components/customNavigationHook";

const {
  FETCH_RATE_CARD_CP,
  VALIDATE_PUBLIC_GST_NUMBER,
  POST_NEW_RETAIL_BOOKING,
  UPDATE_SINGLE_BOOKING,
  NBA_UPDATE_SINGLE_BOOKING,
  PRINT_RETAIL_INVOICE,
  VERIFY_GST,
} = urls;

const NewRetailUX = () => {
  const [retailNewForm] = Form.useForm();
  const token = getToken();

  const [ewayForm] = Form.useForm();
  const [returnAddressform] = Form.useForm();
  const [childDrawerform] = Form.useForm();
  // const [chargableWeight, setChargableWeight] = useState(0);
  const currentEnv = process.env.REACT_APP_ENV;

  const [fileList, setFileList] = useState([]);
  const [ewayDrawer, setEwayDrawer] = useState(false);
  const [childDrawer, setChildDrawer] = useState(false);
  const [returnCheck, setReturnCheck] = useState(true);
  const [childShipments, setChildShipments] = useState([]);
  const [returnFormData, setReturnFormData] = useState([]);
  const [mainBaseCharge, setMainBaseCharge] = useState(null);
  const [checkLocalStateTax, setCheckLocalStateTax] = useState(true);
  const [resetForm, setResetForm] = useState(false);
  const [recentBookingsData, setRecentBookingsData] = useState([]);
  const [returnAddressDrawer, setReturnAddressDrawer] = useState(false);

  const [checkReturnAdded, setCheckReturnAdded] = useState(null);
  const user_premiseId = JSON.parse(localStorage?.getItem("userId"));
  const [user_Info, setUser_Info] = useState(
    JSON.parse(localStorage.getItem("userinfo"))
  );

  const company = JSON.parse(localStorage.getItem("selectedCompany")) || null;
  const debounceTimeout = useRef(null);
  const [isNonDox, setIsNonDox] = useState("DOX");
  const navigate = useCustomNavigate();

  const [freightCharge, setFreightCharge] = useState(0);
  const [docValidate, setDocValidate] = useState({});
  const [isODAIncluded, setisODAIncluded] = useState(0);
  const [docAdded, setDocAdded] = useState(null);

  const [summaryData, setSummaryData] = useState({
    ["Chargeable Weight"]: 0,
    ["Rates as per Rate Master"]: 0,
    ["Value of Shipment"]: 0,
    ["Basic Charge"]: 0,
    ["FOV Charge"]: 0,
    ["Insurance Charge"]: 0,
    ["SGST @ 9 %"]: 0,
    ["CGST @ 9 %"]: 0,
    ["IGST @ 18 %"]: 0,
    ["Freight Charges"]: 0,
    ["ODA charges"]: 0,
    ["Packaging charges"]: 0,
    ["Total charges"]: 0,
  });

  const [docLoading, setdocLoading] = useState(false);
  const lastPayloadRef = useRef(null);
  const [resetService, setResetService] = useState(false);
  const [checkRateCardZero, setCheckRateCardZero] = useState(false);
  const { id, date } = useParams();

  const {
    insuredOptions,

    loading,
    travelByOptions,
    servicesOptions,
    pinCodeServiceableStatus,
    contentDiscriptionData,
    // reviverNameAndAddress,
    allEwayBills,
    mainEwayValidationStatus,
    getSenderPincode,

    setPinCodeServiceableStatus,
    setAllEwayBills,
    getDeliveryPincode,
    getContentDiscriptionData,

    documentValidate,
    handleOnEnter,

    eWayBillHandle,
    setMainEwayValidationStatus,
    reviverNameAndAddress,
    getRecvNameAddressList,
    senderPinCodeServiceableStatus,
    setSenderPinCodeServiceableStatus,
    setReviverStateCity,
    setLoading,
    reviverStateCity,
    getReturnDeliveryPincode,
    returnPinCodeServiceableStatus,
    setReturnPinCodeServiceableStatus,
    setServiceOptions,
    getNBASingleShipmentDetails,
    editShipmentDetails,
    pincodeLoading,
  } = useClientAndDepartment(user_premiseId?.userInfo, retailNewForm);

  const history = useLocation();

  const [lastSubmitTime, setLastSubmitTime] = React.useState(0);
  const THROTTLE_TIME = 2000; // 2 seconds

  useEffect(() => {
    if (id == undefined) {
      getSenderPincode(user_premiseId?.premises?.pincode);
    }
  }, [id]);

  useEffect(() => {
    retailNewForm.setFieldsValue({
      senderPincode: user_premiseId?.premises?.pincode,
      cess: "0",
      kycType: "aadhar",
      shipmentType: "DOX",
      pktCharge: 0,
      discountBooking: "no",
      travelBy: "SURFACE",
      insured: "NO",
      IsSez: "NO",
      weight: "50",
      value: 0,
      paymentMode: "CASH",
      service: "STANDARD",
      kycDocumentType: "AADHAAR",

      // documentNumber: "24007100175007",
      // deliveryPincode: "560016",
      // senderName: "Test",
      // senderAddress: "M ROAD",
      // senderMobileNumber: "7887997979",
      // receiverName: "ASCJAHSHJ",
      // receiverAddress: "KNDANDWQDNW",
      // mobileNumber: "2343443344",

      // content: "DOCUMENT - FORM, CATALOGUE & PAPER",
      // freight: 30,
    });

    focusFirstInputAndScrollToTop("documentNumber");
    getRecvNameAddressList("Cash");
    getContentDiscriptionData();
    setRecentBookingsData(
      JSON.parse(localStorage.getItem("retailRecentBookings") || "[]")
    );
  }, []);

  const handleRecentBookingsData = (data) => {
    setRecentBookingsData(data);
  };

  const addresCardStyles = {
    width: "auto",
    boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
    marginBottom: "1rem",
    padding: "0",
    background: "#F7F5F5",
  };

  const iconStyles = {
    color: "#2e77d0",
    fontSize: "1.17em",
  };

  const SummaryComponent = ({ summaryData, docType, isODAIncluded }) => {
    let temp = {};
    let checkType = docType?.toUpperCase() === "DOX" ? "(Gms)" : "(Kg)";

    if (summaryData && typeof summaryData === "object") {
      if (checkLocalStateTax) {
        // if local then remove igst
        temp = Object.fromEntries(
          Object.entries(summaryData)?.filter(
            ([key]) =>
              key !== "IGST @ 18 %" && (isODAIncluded || key !== "ODA charges")
          )
        );
      } else {
        // if not local, remove cgst & sgst
        temp = Object.fromEntries(
          Object.entries(summaryData)?.filter(
            ([key]) =>
              key !== "CGST @ 9 %" &&
              key !== "SGST @ 9 %" &&
              (isODAIncluded || key !== "ODA charges")
          )
        );
      }
    }

    return (
      <div className="p-0-5">
        {Object.entries(temp)?.map(([key, value]) => (
          <div
            key={key}
            className="space-between summary-items"
            style={{ marginBottom: "5px" }}
          >
            <b>{key?.toUpperCase()}</b>
            <b>{value}</b>
          </div>
        ))}
      </div>
    );
  };

  const setRateAndGetTat = (apiRes, cWgt) => {
    setMainBaseCharge(apiRes?.total);

    const basePrice = apiRes?.total || 0;
    const getAllTaxes = calculateCharges(apiRes?.total);
    const freightValue = +basePrice?.toFixed(2) || 0;

    retailNewForm.setFieldsValue({
      freight: +freightValue,
      pktCharge: editShipmentDetails?.items?.isDiscountBooking
        ? +editShipmentDetails?.items?.charges?.packagingCharge
        : 0,
    });

    if (apiRes?.igst !== 0) {
      setCheckLocalStateTax(false);
    } else {
      setCheckLocalStateTax(true);
    }
    if (apiRes?.odaCharges > 0) {
      setisODAIncluded(apiRes?.odaCharges);
    } else {
      setisODAIncluded(null);
    }

    // Prepare the new data object
    const newSummaryData = {
      ...summaryData,
      ["Chargeable Weight"]:
        cWgt === 0 ? +retailNewForm.getFieldValue("weight") : cWgt,
      ["Rates as per Rate Master"]: apiRes?.baseRate || 0,
      ["Value of Shipment"]: retailNewForm.getFieldValue("value"),
      ["Basic Charge"]: +apiRes?.baseRateWithoutGst?.toFixed(2) || 0,
      ["FOV Charge"]: apiRes?.valuationCharges || 0,
      ["Insurance Charge"]: apiRes?.insuranceCharges || 0,
      ["SGST @ 9 %"]: +getAllTaxes?.sgst?.toFixed(2) || 0,
      ["CGST @ 9 %"]: +getAllTaxes?.cgst?.toFixed(2) || 0,
      ["IGST @ 18 %"]: +getAllTaxes?.igst?.toFixed(2) || 0,

      ["Freight Charges"]: Math.floor(freightValue)
        ? +freightValue?.toFixed(2)
        : +freightValue,

      ["ODA charges"]: apiRes?.odaCharges || 0,
      ["Packaging charges"]: editShipmentDetails?.items?.isDiscountBooking
        ? +editShipmentDetails?.items?.charges?.packagingCharge
        : 0,
      ["Total charges"]:
        (freightValue + +retailNewForm.getFieldValue("pktCharge"))?.toFixed(
          2
        ) || 0,
    };
    // console.log(
    //   editShipmentDetails?.items?.isDiscountBooking,
    //   "editShipmentDetails"
    // );
    // console.log(
    //   editShipmentDetails?.items?.charges?.packagingCharge,
    //   "packing"
    // );
    if (company?.isRegularNGST == false) {
      newSummaryData["IGST @ 18 %"] = 0;
      newSummaryData["SGST @ 9 %"] = 0;
      newSummaryData["CGST @ 9 %"] = 0;
    }

    // Update state
    setSummaryData(newSummaryData);
  };

  useEffect(() => {
    if (id) {
      getNBASingleShipmentDetails(id);
    }
  }, [id]);

  useEffect(() => {
    if (editShipmentDetails?.items) {
      const value = editShipmentDetails.items;

      // You can customize this if `childShipments` were present

      setChildShipments(
        value?.childShipments?.map((val) => ({
          childDocumentNumber: val?.documentNo,
          weight: val?.dwsWeight || 0,
          width: val?.dwsWidth || 0,
          length: val?.dwsLength || 0,
          height: val?.dwsHeight || 0,
          editable: false,
          volumetricWeight: val?.childVolWeight || val?.volumatricWeight || 0,
          value: val?.value || 0,
        })) || []
      );

      const mappedFiles =
        value?.documents?.map((doc, index) => ({
          name: doc?.documentType,
          url: doc?.documentLink,
          uid: `${index}`,
          showRemove: false,
        })) || [];

      setFileList(mappedFiles);
      // setFileData(mappedFiles);

      // transMode: value?.transMode,
      // ewayBillNumber: value?.ewayBillNumber,
      // name: value?.name,
      // editable: true,
      // expiryDate: value?.expiryDate,
      // ewayBillCreateDate: value?.ewayBillCreateDate,

      setAllEwayBills(
        value?.eWayBills?.map((val) => ({
          ...val,
          editable: false,
          ewayBillNumber: val?.eway,
        })) || null
      );
      setIsNonDox(value?.shipmentType?.toUpperCase());
      // console.log(value?.charges, "value");
      // console.log(value?.charges?.packagingCharge, "pkf");

      retailNewForm.setFieldsValue({
        documentNumber: value?.documentNo || null,
        discountBooking: value?.isDiscountBooking ? "yes" : "no",
        // department: null,
        // clientName: value.username || null,
        deliveryPincode: value?.receiverAddress?.zip || null,
        areaId: value?.receiverAddress?.city || null,
        content: value?.metadata?.content || null,
        weight: value?.dwsWeight || 0,
        length: value?.dwsLength || 0,

        width: value?.dwsWidth || 0,
        height: value?.dwsHeight || 0,
        volumetricWeight: value?.volumetricWeight || "0.00",
        value: value?.metadata?.value || null,
        senderGstNumber: value?.pickupAddress?.gst || null,
        shipmentType: value?.shipmentType?.toUpperCase() || null,
        service: value?.deliveryPromise?.toUpperCase() || null,
        travelBy: value?.travelBy?.toUpperCase() || null,

        receiverName: value?.receiverAddress?.name || null,
        receiverAddress: value?.receiverAddress?.address1 || null,
        mobileNumber: value?.receiverAddress?.phone || "0",
        receiverEmail: value?.receiverAddress?.email || null,

        billRemark: value?.metadata?.remark || null,
        insured: value?.metadata?.insured ? "YES" : "NO",
        kycDocumentNo: value?.metadata?.kycDocumentNo,
        kycDocumentType: value?.metadata?.kycDocumentType?.toUpperCase(),

        isSez: value?.metadata?.isSez,
        senderName: value?.pickupAddress?.name?.toUpperCase() || "",
        senderAddress: value?.pickupAddress?.address1?.toUpperCase() || "",
        senderMobileNumber: value?.pickupAddress?.phone || "",
        senderEmail: value?.pickupAddress?.email || "",
        senderGST: value?.pickupAddress?.gst || null,
        senderPincode: value?.pickupAddress?.zip,
        freight: parseFloat(value?.charges.amount) || 0,
        pktCharge: parseFloat(value?.charges.packagingCharge) || 0,
      });
      let sgst = parseFloat(value?.charges?.sgst) || 0;
      let cgst = parseFloat(value?.charges?.cgst) || 0;
      let igst = parseFloat(value?.charges?.igst) || 0;

      let gstDetails = {};
      setSummaryData({
        // ...value?.charges,
        // ["Chargeable Weight"]: value?.dwsWeight,
        ["Rates as per Rate Master"]: value?.charges?.rateAsPerRateCard,
        ["Value of Shipment"]: value?.metadata?.value,
        ["Basic Charge"]: value?.charges?.subTotal,
        ["FOV Charge"]: value?.charges?.fovCharge,
        ["Insurance Charge"]: value?.charges?.insuranceCharge,
        ["SGST @ 9 %"]: value?.charges?.sgst,
        ["CGST @ 9 %"]: value?.charges?.cgst,
        ["IGST @ 18 %"]: value?.charges?.igst,
        ["Freight Charges"]: value?.charges?.amount,
        ["ODA charges"]: value?.charges?.odaCharge,
        ["Packaging charges"]: value?.charges?.packagingCharge,
        ["Total charges"]: value?.charges?.totalCharge,
      });

      if (igst > 0) {
        gstDetails["IGST @ 18 %"] = igst;
      } else {
        gstDetails["SGST @ 9 %"] = sgst;
        gstDetails["CGST @ 9 %"] = cgst;
      }

      // setSummaryData({
      // ["Chargeable Weight"]: Math.max(
      //   +value?.dwsWeight,
      //   +value?.volumetricWeight
      // ),
      // ["Rates as per Rate Master"]: 0,
      // ["Value of Shipment"]: value?.metadata?.value || 0,
      // ["Basic Charge"]: parseFloat(value?.charges.freight) || 0,
      // ["FOV Charge"]: 0,
      // ["Insurance Charge"]: parseFloat(value?.charges?.insuranceCharge) || 0,
      // ...gstDetails,

      // ["Freight Charges"]: parseFloat(value?.charges.freight) || 0,
      // ["ODA charges"]: 0,
      // ["Packaging charges"]: parseFloat(value?.charges.packagingCharge) || 0,
      // ["Total charges"]: parseFloat(value?.charges.totalCharge) || 0,
      // });
    }
  }, [editShipmentDetails]);

  const updateShipmentDetails = async (value) => {
    const eWayBills = allEwayBills?.map((bill) => ({
      eway: bill?.ewayBillNumber,
      date: bill?.ewayBillCreateDate,
      eway_bill_crt_date: bill?.ewayBillCreateDate,
      ewb_bill_exp_date: bill?.expiryDate,
      trans_mode:
        bill?.transMode?.toLowerCase() === "road"
          ? "surface"
          : bill?.transMode?.toLowerCase(),
      name: "",
    }));

    let payload = {
      documents: fileList?.length
        ? fileList
            ?.filter((val) => val?.showRemove !== false)
            ?.map((val) => ({
              documentLink: val?.response?.data?.filePath || val?.url,
              documentType: val?.documentType || val?.name,
            }))
        : [],

      eWayBills: eWayBills || [],
    };

    setLoading(true);

    let res = await API.Api(NBA_UPDATE_SINGLE_BOOKING + id).patchIdHeader(
      payload
    );

    if (res?.status) {
      setLoading(false);
      message.success("Booking updated successfully");

      let tempIndex = recentBookingsData?.findIndex(
        (item) => item?.awbNumber == id
      );
      if (!recentBookingsData[tempIndex]) {
        recentBookingsData[tempIndex] = {};
      }

      recentBookingsData[tempIndex].weight = value?.weight;
      recentBookingsData[tempIndex].receiverName = value?.receiverName;

      localStorage.setItem(
        "RetailrecentBookings",
        JSON.stringify(recentBookingsData)
      );

      navigate("/viewBooking", { state: history?.state });
    } else {
      setLoading(false);
      // setEditShipmentDetails(null);
      message.error(res?.response?.data?.message || "Network error");
    }
  };

  const onSubmitFormData = (values) => {
    const now = Date.now();
    if (now - lastSubmitTime < THROTTLE_TIME) {
      // If less than 2 seconds have passed since last submission, prevent submission
      return;
    }
    setLastSubmitTime(now);

    if (
      id &&
      !retailNewForm.getFieldValue("discountBooking")?.toLowerCase() == "yes"
    ) {
      updateShipmentDetails(values);
    } else {
      onPostSubmit(values);
    }
  };

  const onPostSubmit = async (formData) => {
    // console.log(formData, "formData");

    if (!returnCheck && returnFormData == null) {
      setLoading(false);
      message.error("Please add return address");
      return;
    }

    if (checkRateCardZero) {
      message.error("Rates are not availabel");
      return;
    }

    if (!checkGSTStatus?.status) {
      focusFirstInputAndScrollToTop("senderGST");
      return;
    }

    if (docValidate?.status == "error") {
      message.error(docValidate?.message);
      return;
    }

    if (pinCodeServiceableStatus?.status == "error") {
      message.error("Pincode is " + pinCodeServiceableStatus?.msg);
      return;
    }

    if (
      senderPinCodeServiceableStatus?.msg !== "Non-Serviceable" &&
      senderPinCodeServiceableStatus?.msg !== null
    ) {
      message.error("Sender pincode is " + senderPinCodeServiceableStatus?.msg);
      return;
    }

    if (childShipments?.length > 0) {
      Object.keys(formData)?.forEach((key) => {
        if (key?.includes("Child_")) {
          delete formData[key];
        }
      });
    }

    if (mainEwayValidationStatus?.status == "error") {
      message.error(mainEwayValidationStatus?.msg || "Invalid Eway");
      return;
    }

    if (formData?.value > 50000 && allEwayBills?.length == 0) {
      message.error("Add E-way bill");
      return;
    }
    setLoading(true);

    let payload;

    const eWayBills = allEwayBills?.map((bill) => ({
      eway: bill?.ewayBillNumber,
      date: null,
      eway_bill_crt_date: bill?.ewayBillCreateDate,
      ewb_bill_exp_date: bill?.expiryDate,
      trans_mode:
        bill?.transMode?.toLowerCase() === "road"
          ? "surface"
          : bill?.transMode?.toLowerCase(),
      name: "",
    }));

    const transformedChildData = childShipments?.map((item) => ({
      documentNo: String(item?.childDocumentNumber),
      value: 0,
      dwsWeight: +item?.weight || 0,
      dwsLength: +item?.length || 0,
      dwsWidth: +item?.width || 0,
      dwsHeight: +item?.height || 0,
    }));

    const company = JSON.parse(localStorage.getItem("selectedCompany")) || null;

    const serviceMap = {
      "fast track": "Fastrack",
      "value plus": "Value Plus",
      vayuquick: "vayuQuick",
      vayuquick_pro: "vayuQuickPro",
    };

    const deliveryPromise =
      serviceMap[formData?.service?.toLowerCase()] || "Standard";
    payload = {
      username:
        user_premiseId?.userInfo?.firstName +
        " " +
        user_premiseId?.userInfo?.lastName,

      documentNo: String(formData?.documentNumber) || null,
      isBulk: childShipments?.length > 0,
      bookingType: "retail",
      areaId: null,
      shipmentType: formData?.shipmentType?.toUpperCase() || "DOX",
      travelBy: formData?.travelBy == "SURFACE" ? "Surface" : "Air" || null,

      //vayuQuick
      // vayuQuickPro
      deliveryPromise: deliveryPromise,

      // clientId: 953029,
      companyId: +company?.key || null,

      dwsWeight: +formData?.weight || 0,
      dwsLength: +formData?.length || 0,
      dwsWidth: +formData?.width || 0,
      dwsHeight: +formData?.height || 0,

      pickupAddress: {
        addressType: "pickup",
        name: formData?.senderName || null,
        email: formData?.senderEmail || null,
        gst: formData?.senderGST || null,
        phone: String(formData?.senderMobileNumber || ""),
        address1: formData?.senderAddress || null,
        address2: null,
        landmark: formData?.senderLandmark || null,

        city:
          senderPinCodeServiceableStatus?.city ||
          user_premiseId?.premises?.city,

        state:
          senderPinCodeServiceableStatus?.state ||
          user_premiseId?.premises?.state,
        country: formData?.senderCountry || null,
        zip: String(formData?.senderPincode || ""),
        latitude: formData?.pickupLatitude || null,
        longitude: formData?.pickupLongitude || null,
      },

      receiverAddress: {
        addressType: "shipping",
        name: formData?.receiverName || null,
        email: formData?.receiverEmail || null,
        gst: formData?.receiverGst || null,
        phone: String(formData?.mobileNumber || ""),
        address1: formData?.receiverAddress || null,
        address2: null,
        landmark: formData?.receiverLandmark || null,
        city: pinCodeServiceableStatus?.city || reviverStateCity?.city || null,
        state:
          pinCodeServiceableStatus?.state || reviverStateCity?.state || null,

        country: formData?.receiverCountry || null,
        zip: String(formData?.deliveryPincode || ""),
        latitude: formData?.deliveryLatitude || null,
        longitude: formData?.deliveryLongitude || null,
      },

      returnAddress: !returnCheck
        ? {
            addressType: "return",
            name: returnFormData?.returnName || null,
            email: returnFormData?.returnEmail || null,
            gst: formData?.senderGST || null,
            phone: String(returnFormData?.returnMobileNumber || ""),
            address1: returnFormData?.returnAddressLine1 || null,
            address2: null,
            landmark: formData?.senderLandmark || null,
            city:
              senderPinCodeServiceableStatus?.city ||
              user_premiseId?.premises?.city,

            state:
              senderPinCodeServiceableStatus?.state ||
              user_premiseId?.premises?.state,
            country: formData?.senderCountry || null,
            zip: String(returnFormData?.returnPincode || ""),
            latitude: formData?.pickupLatitude || null,
            longitude: formData?.pickupLongitude || null,
          }
        : {
            addressType: "return",
            name: formData?.senderName || null,
            email: formData?.senderEmail || null,
            gst: formData?.senderGST || null,
            phone: String(formData?.senderMobileNumber || ""),
            address1: formData?.senderAddress || null,
            address2: null,
            landmark: formData?.senderLandmark || null,
            city:
              senderPinCodeServiceableStatus?.city ||
              user_premiseId?.premises?.city,

            state:
              senderPinCodeServiceableStatus?.state ||
              user_premiseId?.premises?.state,
            country: formData?.senderCountry || null,
            zip: String(formData?.senderPincode || ""),
            latitude: formData?.pickupLatitude || null,
            longitude: formData?.pickupLongitude || null,
          },

      documents:
        fileList?.map((file) => ({
          documentLink: file?.response?.data?.filePath || null,
          documentType: file?.documentType || null,
        })) || [],

      eWayBills: eWayBills || [],

      childShipments: transformedChildData || [],

      // charges: {
      //   amount: +summaryData["Freight Charges"] || 0,
      //   mode:
      //     formData?.paymentMode?.toUpperCase() == "CASH" ? "cash" : "online", // upi
      //   currency: "INR",
      //   packagingCharge: +summaryData["Packaging charges"] || 0,
      //   totalCharge: +summaryData["Total charges"] || 0
      // },

      charges: {
        amount: +summaryData["Freight Charges"] || 0,
        mode:
          formData?.paymentMode?.toUpperCase() == "CASH" ? "cash" : "online", // upi
        currency: "INR",

        // ["Chargeable Weight"]: +summaryData["Chargeable Weight"] || 0,
        // freightCharges: +summaryData["Freight Charges"] || 0,
        // value: +summaryData["Value of Shipment"] || 0,

        rateAsPerRateCard: +summaryData["Rates as per Rate Master"] || 0,
        odaCharge: +summaryData["ODA charges"] || 0,
        subTotal: +summaryData["Basic Charge"] || 0,
        fovCharge: +summaryData["FOV Charge"] || 0,
        insuranceCharge: +summaryData["Insurance Charge"] || 0,
        sgst: +summaryData["SGST @ 9 %"] || 0,
        cgst: +summaryData["CGST @ 9 %"] || 0,
        igst: +summaryData["IGST @ 18 %"] || 0,

        packagingCharge: +summaryData["Packaging charges"] || 0,
        totalCharge: +summaryData["Total charges"] || 0,
      },
      cod: summaryData?.cod || null,
      pod: summaryData?.pod || null,

      metadata: {
        value: +formData?.value || 0,
        content: formData?.content || null,
        remark: formData?.remark || "",
        insured: formData?.insured?.toUpperCase() == "YES" ? true : false,
        fov: formData?.fov || false,
        isSez: formData?.isSez?.toLowerCase() === "yes" ? true : false,
        kycDocumentNo: formData?.kycDocumentNo || null,
        kycDocumentType: formData?.kycDocumentType || null,
        // kycDocumentNo: null,
        // kycDocumentType: null,
      },
    };
    let url = null;

    if (
      retailNewForm.getFieldValue("discountBooking")?.toLowerCase() == "yes"
    ) {
      if (currentEnv === "qa") {
        url = urls.CONFIRM_BOOKING_UTM;
      } else {
        url = urls.POST_NEW_RETAIL_BOOKING_DISCOUNT;
      }
      payload.isDiscountBooking = true;
      payload.isDiscountApplied = false;
      payload.status = "DRAFT";
      if (id) {
        url = urls.POST_NEW_RETAIL_BOOKING_DISCOUNT + "/" + id;
      }
    } else {
      if (currentEnv === "qa") {
        url = urls.CONFIRM_BOOKING_UTM;
      } else {
        url = urls.POST_NEW_RETAIL_BOOKING;
      }
      payload.isDiscountBooking = false;
      payload.status = "BOOKED";
    }

    let headers = {
      headers: {
        Authorization: token,
        cpid: user_Info?.spId,
        user_id: user_Info?.sevasetuUserId,
      },
    };

    let response = null;

    try {
      if (
        id &&
        retailNewForm.getFieldValue("discountBooking")?.toLowerCase() == "yes"
      ) {
        response = await axios.patch(url, payload, headers);
      } else {
        response = await axios.post(url, payload, headers);
      }

      if (response?.data?.status) {
        setLoading(false);
        setAllEwayBills(null);
        setChildShipments(null);

        if (
          id &&
          retailNewForm.getFieldValue("discountBooking")?.toLowerCase() == "yes"
        ) {
          navigate("/viewBooking", { state: history?.state });
        }

        // openNotificationWithIcon("success", String(formData?.documentNumber));

        // openNotificationWithIcon("success", String(formData?.documentNumber));
        resetCallBack();
      } else {
        setLoading(false);
        message.error(response?.data?.message || "Request failed");
      }
    } catch (error) {
      setLoading(false);
      message.error(error?.response?.data?.message || "Network error occurred");
    }
  };

  function resetCallBack() {
    setAllEwayBills([]);
    setFileList([]);
    setChildShipments([]);
    setPinCodeServiceableStatus({});
    setReturnPinCodeServiceableStatus({});
    setResetService(true);
    // setUseGoogleAddr(false);

    const keysToInclude = [
      // "shipmentType",
      "travelBy",
      "documentNumber",
      "senderPincode",
    ];
    const values = retailNewForm.getFieldValue();
    const currentDateTime = moment()?.format("YYYY-MM-DD HH:mm:ss");

    let temp = [...recentBookingsData];
    openNotificationWithIcon("success", +values?.documentNumber);
    // sendSms(+values?.documentNumber, values?.mobileNumber);
    // sendWhatApp(
    //   values?.documentNumber,
    //   values?.receiverName,
    //   values?.senderMobileNumber,
    //   reviverStateCity?.city,
    //   reviverStateCity?.state
    // );

    const isDiscountYesNEdit =
      values?.discountBooking?.toLowerCase() === "yes" && id;
    const awbNumber = +values?.documentNumber;
    const shipmentType = values?.shipmentType?.toUpperCase() || "NA";
    const shipmentUnit = shipmentType === "NON-DOX" ? " KG" : " GMS";

    const totalWeight =
      (
        (+values?.weight || 0) +
        (childShipments?.reduce((acc, curr) => acc + (+curr?.weight || 0), 0) ||
          0)
      )?.toString() + shipmentUnit;

    const shipmentData = {
      awbNumber,
      bookingTime: currentDateTime || "NA",
      discountBooking: "no",
      bookingType: "Cash",
      serviceType: values?.service || "NA",
      travelBy: values?.travelBy || "NA",
      type: shipmentType || "NA",
      senderName: values?.senderName || "NA",
      weight: totalWeight || "NA",
      toCenter: reviverStateCity?.city || "NA",
      receiverName: values?.receiverName || "NA",
    };

    if (isDiscountYesNEdit) {
      const index = temp?.findIndex((e) => e?.awbNumber === awbNumber);
      if (index !== -1) {
        temp[index] = {
          ...temp[index],
          ...shipmentData,
        };
      }
    } else {
      temp.unshift(shipmentData);
    }

    temp = temp?.slice(0, 5);
    setRecentBookingsData(temp);

    localStorage.setItem("retailRecentBookings", JSON.stringify(temp));
    setReviverStateCity({});

    retailNewForm.resetFields(
      Object.keys(values).filter((key) => !keysToInclude?.includes(key))
    );

    let documentNumber = +values?.documentNumber;

    setIsNonDox("DOX");
    setResetForm(true);

    setAllEwayBills([]);
    setFileList([]);
    setChildShipments([]);

    setCheckReturnAdded(null);
    setCheckLocalStateTax(true);
    setReturnCheck(true);
    setMainBaseCharge(null);
    setReturnFormData([]);
    setFreightCharge(0);
    setDocValidate({});
    setPinCodeServiceableStatus({});

    clearRateCardData();
    ewayForm.resetFields();
    returnAddressform.resetFields();
    childDrawerform.resetFields();

    retailNewForm.setFieldsValue({
      documentNumber: ++documentNumber,
      shipmentType: "DOX",
      discountBooking: "no",
      pktCharge: 0,
      travelBy: "SURFACE",
      insured: "NO",
      IsSez: "NO",
      weight: values?.shipmentType?.toLowerCase() == "dox" ? 50 : 1,
      value: 0,
      freight: 0,
      paymentMode: "CASH",
      service: "STANDARD",
      kycDocumentType: "AADHAAR",
    });
    focusFirstInputAndScrollToTop("documentNumber");
    // getRecvNameAddressList("Cash");
  }

  const applyFocusEffect = (e) => {
    e.target.style.transform = "scale(1.05)";
    e.target.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.3)";
  };

  const removeFocusEffect = (e) => {
    e.target.style.transform = "scale(1)";
    e.target.style.boxShadow = "none";
  };

  const cashPrint = async (id) => {
    let response = await API.Api(
      PRINT_RETAIL_INVOICE + id
    ).getWithUserNPremiseHeader();
    if (response?.status) {
      let data = response?.response?.data?.data;
      data?.invoiceUrl
        ? window.open(data?.invoiceUrl)
        : message.error("Internal server error.");
    } else {
      message.error(
        response?.response?.data?.message || "Internal server error."
      );
    }
  };

  const openNotificationWithIcon = (type, docNum) => {
    notification[type]({
      message: (
        <h3 className="alert-">
          {" "}
          {id ? "Booking updated" : "Booking completed"} successfully{" "}
        </h3>
      ),

      description: (
        <>
          <h5 className="order-id">
            Document no.&nbsp;{" "}
            <b>{docNum || retailNewForm.getFieldValue("documentNumber")}</b>
          </h5>

          {childShipments?.length > 0 ? (
            <h5>
              Child document no.&nbsp;{" "}
              <b>
                {childShipments?.map((e) => e?.childDocumentNumber)?.join(", ")}
              </b>
            </h5>
          ) : (
            ""
          )}
          {retailNewForm.getFieldValue("discountBooking")?.toLowerCase() ==
            "no" && (
            <a onClick={() => cashPrint(docNum)}>
              Click here to Download the invoice
            </a>
          )}
        </>
      ),
    });
  };

  function handleReturnCheckBox(params) {
    setReturnCheck(params.target.checked);
    setCheckReturnAdded(null);
    // setCheckReturnAdded(!checkReturnAdded);
    if (params.target.checked) {
      setReturnCheck(true);
    } else {
      setReturnCheck(false);
      setReturnFormData(null);
    }
  }

  const updateSummaryData = (updates) => {
    setSummaryData((prevData) => ({
      ...prevData,
      ...updates,
    }));
  };

  function calculateGST(amount, gstRate) {
    const x = amount / gstRate;
    let temp = amount - x;
    return +temp;
  }

  function calculateCharges(basePrice) {
    let chargesAfterGST;
    let igst = calculateGST(+basePrice, 1.18);

    let sgst = igst / 2;
    let cgst = igst / 2;

    if (basePrice?.igst !== 0) {
      chargesAfterGST = basePrice - igst;
    } else {
      chargesAfterGST = basePrice - (sgst + cgst);
    }
    if (company?.isRegularNGST == false) {
      igst = 0;
      sgst = 0;
      cgst = 0;
    }
    return { chargesAfterGST, igst, sgst, cgst };
  }

  const calculateAndSetSummary = (freight, packetCharge) => {
    const total = freight + packetCharge;
    const taxes = calculateCharges(total) || {};
    let data = retailNewForm.getFieldsValue("");

    const totalFixed = +total?.toFixed(2) || 0;

    const fovCharge = +summaryData["FOV Charge"] || 0;
    const insuranceCharge = +summaryData["Insurance Charge"] || 0;
    const packetChargess = +data.pktCharge || 0;

    const extraCharges = fovCharge + insuranceCharge + packetChargess;

    const baseBeforeExtras = (totalFixed - extraCharges) / 1.18;

    const basicCharge = baseBeforeExtras.toFixed(2);

    updateSummaryData({
      ...(company?.isRegularNGST !== false && {
        ["Basic Charge"]: basicCharge,
      }),
      ["IGST @ 18 %"]: taxes?.igst?.toFixed(2) || "0.00",
      ["SGST @ 9 %"]: taxes?.sgst?.toFixed(2) || "0.00",
      ["CGST @ 9 %"]: taxes?.cgst?.toFixed(2) || "0.00",
      ["Freight Charges"]: freight.toFixed(2),
      ["Packaging charges"]: (+packetCharge).toFixed(2),
      ["Total charges"]: total?.toFixed(2),
    });
  };

  const onPacketChange = (e) => {
    const packetChargeValue = Math.max(0, +e.target.value);
    const freight = +summaryData["Freight Charges"] || 0;
    calculateAndSetSummary(freight, packetChargeValue);
  };

  const onFreightChange = (e) => {
    const freightValue = Math.max(0, +e.target.value);
    setFreightCharge(freightValue);
    const packetCharge = +summaryData["Packaging charges"] || 0;
    calculateAndSetSummary(freightValue, packetCharge);
  };

  const handleRateCardCall = () => {
    setResetForm(false);
    let values = retailNewForm.getFieldsValue();

    const temp = ["weight", "shipmentType", "travelBy", "service"];
    if (retailNewForm.getFieldValue("shipmentType")?.toUpperCase() !== "DOX") {
      temp.push("width", "length", "height");
    }

    const areAllKeywordsPresent = temp?.every((key) => {
      const value = values[key];
      return (
        value !== undefined && value !== null && value !== "" && value !== 0
      );
    });

    if (areAllKeywordsPresent) {
      getRateCard();
    }
  };

  function clearRateCardData() {
    setSummaryData({
      ["Chargeable Weight"]: 0,
      ["Rates as per Rate Master"]: 0,
      ["Value of Shipment"]: 0,
      ["Basic Charge"]: 0,
      ["FOV Charge"]: 0,
      ["Insurance Charge"]: 0,
      ["SGST @ 9 %"]: 0,
      ["CGST @ 9 %"]: 0,
      ["IGST @ 18 %"]: 0,
      ["Freight Charges"]: 0,
      ["ODA charges"]: 0,
      ["Packaging charges"]: 0,
      ["Total charges"]: 0,
    });
  }

  useEffect(() => {
    if (pinCodeServiceableStatus?.status === "success" && id == undefined) {
      handleRateCardCall();
    }
  }, [pinCodeServiceableStatus]);

  useEffect(() => {
    if (editShipmentDetails?.items?.isDiscountBooking) {
      getDeliveryPincode(
        editShipmentDetails?.items?.receiverAddress?.zip,
        null,
        editShipmentDetails?.items?.deliveryPromise,
        true
      );
      getSenderPincode(editShipmentDetails?.items?.pickupAddress?.zip);
    }
  }, [editShipmentDetails]);

  // useEffect(() => {
  //   if (editShipmentDetails?.items?.isDiscountBooking) {
  //     if (pinCodeServiceableStatus?.status === "success") {
  //       if (senderPinCodeServiceableStatus?.status === "success") {
  //         handleRateCardCall();
  //       }
  //     }
  //   }
  // }, [
  //   pinCodeServiceableStatus,
  //   senderPinCodeServiceableStatus,
  //   editShipmentDetails,
  // ]);

  useEffect(() => {
    if (childShipments && !childDrawer && id == undefined) {
      handleRateCardCall();
    }
  }, [childShipments, childDrawer]);

  function handleFormValueChange(temp) {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    if (temp?.shipmentType == "DOX") {
      setIsNonDox("DOX");
    }

    const keywords = [
      "weight",
      "shipmentType",
      "travelBy",
      // "senderGST",
      // "senderPincode",
      // "deliveryPincode",
      "width",
      "length",
      "height",
      "insured",
      "value",
    ];

    function checkForKey(temp, keywords) {
      const tempKeys = Object.keys(temp);
      return keywords.some((keyword) => tempKeys.includes(keyword));
    }

    if (checkForKey(temp, keywords)) {
      debounceTimeout.current = setTimeout(async () => {
        // clearRateCardData();
        handleRateCardCall();
      }, 800);
    }
  }

  const handleChargableWeight = () => {
    let values = retailNewForm.getFieldsValue();

    let totalChargeableWeight = 0;

    if (childShipments?.length) {
      totalChargeableWeight = childShipments?.reduce((sum, item) => {
        const maxWeight = Math.max(
          parseFloat(item.weight),
          parseFloat(item.volumetricWeight)
        );
        return sum + maxWeight;
      }, 0);
    }

    const parentMaxWgt = Math.max(
      parseFloat(values?.weight),
      parseFloat(values?.volumetricWeight)
    );

    const formattedWeight = childShipments?.length
      ? +totalChargeableWeight.toFixed(2) + +parentMaxWgt.toFixed(2)
      : +parentMaxWgt.toFixed(2);

    return formattedWeight || 0;
  };

  useEffect(() => {
    if (senderPinCodeServiceableStatus?.pincode) {
      if (retailNewForm.getFieldValue("senderGST")) {
        checkGST(retailNewForm.getFieldValue("senderGST"));
      }
    }
  }, [senderPinCodeServiceableStatus]);

  const { premises } = JSON.parse(window?.localStorage?.getItem("userId"));

  const [checkGSTStatus, setCheckGSTStatus] = useState({
    status: true,
    stateCode: null,
    error: null,
    stateMatch: null,
  });

  const checkGST = async (event) => {
    let gstNumber;
    if (event?.target) {
      gstNumber = event?.target?.value;
    } else {
      gstNumber = event?.toUpperCase();
    }

    // Reset state if input is empty
    if (!gstNumber || gstNumber?.length === 0) {
      retailNewForm.setFields([
        {
          name: "senderGST",
          errors: [],
        },
      ]);
      setCheckGSTStatus({
        status: true,
        stateCode: null,
        error: null,
        stateMatch: null,
      });
      return;
    }

    if (gstNumber?.length !== 15) return;

    try {
      const response = await API.Api(VERIFY_GST + gstNumber).get();
      const data = response?.response?.data?.result?.gstnDetailed || {};
      const gst = response?.response?.data?.essentials?.gstin || "";
      const isActive = data?.gstinStatus?.toUpperCase() === "ACTIVE";
      const gstStateCode = data?.principalPlaceSplitAddress?.state?.[0]?.[1];
      let matchedStateCode =
        senderPinCodeServiceableStatus?.stateCode || premises?.stateCode;

      if (senderPinCodeServiceableStatus?.stateCode == "TE") {
        matchedStateCode = "TG";
      }

      if (senderPinCodeServiceableStatus?.stateCode == "UA") {
        matchedStateCode = "UT";
      }

      const isStateMatched = gstStateCode === matchedStateCode;

      const errorMsg = isActive
        ? isStateMatched
          ? null
          : "This GST does not belong to sender state"
        : "Invalid GST";

      retailNewForm.setFields([
        {
          name: "senderGST",
          errors: errorMsg ? [errorMsg] : [],
        },
      ]);

      setCheckGSTStatus({
        status: isActive && isStateMatched,
        stateCode: gstStateCode,
        stateMatch: isStateMatched,
        error: errorMsg,
      });

      if (isActive && isStateMatched) {
        getRateCard(true);
      }
    } catch (error) {
      retailNewForm.setFields([
        {
          name: "senderGST",
          errors: ["Error verifying GST"],
        },
      ]);

      setCheckGSTStatus({
        status: false,
        stateCode: null,
        stateMatch: false,
        error: "Error verifying GST",
      });
    }
  };

  const getRateCard = async (callAPI = false) => {
    let values = retailNewForm.getFieldsValue();

    if (pinCodeServiceableStatus?.status !== "success") {
      return;
    }

    let isNonDox =
      retailNewForm.getFieldValue("shipmentType")?.toUpperCase() !== "DOX";

    const serviceMap = {
      "fast track": "fastTrack",
      "value plus": "valuePlus",
      standard: "standard",
      vayuquick: "vayuQuick",
      vayuquick_pro: "vayuQuickPro",
    };

    const serviceInput = values?.service?.trim()?.toLowerCase();

    const matchedKey = Object.keys(serviceMap).find(
      (key) => key.toLowerCase() === serviceInput
    );

    const rateCategory = matchedKey ? serviceMap[matchedKey] : "";

    const payload = {
      type: "CASH",
      userId: company?.key?.toString(),
      amount: +values?.value || 0,
      noOfShipments: 1,
      calculateGst: company?.isRegularNGST,
      isGstApplicable: false,
      fromPincode: user_premiseId?.premises?.pincode,
      toPincode: +values?.deliveryPincode,
      isInsured: values?.insured?.toUpperCase() == "YES" ? true : false,
      isCod: false,
      isPod: false,
      isOda1: false,
      isOda2: false,
      senderGst: values?.senderGST || null,

      rateCategory: rateCategory,

      travelMode:
        retailNewForm.getFieldValue("travelBy")?.toUpperCase() === "SURFACE"
          ? "surface"
          : "air",
      weight: isNonDox ? +values?.weight * 1000 : +values?.weight,
      productType:
        retailNewForm.getFieldValue("shipmentType")?.toUpperCase() === "DOX"
          ? "dox"
          : "nonDox",
    };

    let getChargealeWgt = 0;

    if (isNonDox) {
      getChargealeWgt = handleChargableWeight();
      Object.assign(payload, {
        length: +retailNewForm.getFieldValue("length"),
        height: +retailNewForm.getFieldValue("height"),
        width: +retailNewForm.getFieldValue("width"),
        volumetricWeight: +getChargealeWgt,
      });
    }

    if (
      JSON.stringify(payload) === JSON.stringify(lastPayloadRef.current) &&
      !resetService &&
      !callAPI
    ) {
      // console.log("Payload unchanged. Skipping API call.");
      return;
    }

    lastPayloadRef.current = payload;

    setLoading(true);

    let url;
    if (currentEnv == "qa") {
      url =
        "https://sandbox.bookingapis.innofulfill.com/ratecard/rate-calculation/shipment";
    } else {
      url =
        "https://bookingapis.innofulfill.com/ratecard/rate-calculation/shipment";
    }

    try {
      const response = await axios.post(url, payload, {
        headers: { Authorization: token },
      });

      if (response?.data?.rate?.dox == undefined) {
        setCheckRateCardZero(true);
      } else {
        setCheckRateCardZero(false);
      }

      const rateValue =
        response?.data?.rate?.[payload?.productType]?.[payload?.travelMode]?.[
          payload?.rateCategory
        ];

      if (rateValue) {
        setLoading(false);
        setRateAndGetTat(rateValue, getChargealeWgt);
        setResetService(false);
      } else {
        setLoading(false);
        retailNewForm.setFieldsValue({ service: null });
        message.error("Rate value not found");
        setResetService(true);
      }
    } catch (error) {
      message.error(error?.response?.data?.message || "Rate value not found");
      setLoading(false);
    }
  };

  let docOptions = [
    {
      value: "kyc",
      label: "KYC",
    },
    {
      value: "invoiceDeclaration",
      label: "INVOICE",
    },
    {
      value: "ewayBillPrint",
      label: "E-WAYBILL",
    },
    {
      value: "others",
      label: "OTHERS",
    },
  ];

  let data = [1000221, 4969, 4967, 4967, 4970, "MAHARASHTRA"];

  const enableDiscount =
    data.includes(user_Info?.premiseId) ||
    data.includes(user_Info?.state?.toUpperCase());

  return (
    <>
      <div className="new-retail-container">
        <EwayBillDrawer
          ewayForm={ewayForm}
          allEwayBills={allEwayBills}
          setOpen={(e) => setEwayDrawer(e)}
          open={ewayDrawer}
          setAllEwayBills={setAllEwayBills}
        />
        <ChildDrawer
          childDrawerform={childDrawerform}
          childShipments={childShipments}
          setChildShipments={setChildShipments}
          setOpen={(e) => setChildDrawer(e)}
          open={childDrawer}
          editAwb={id}
        />

        {/* <RetailReturnAddressDrawer
          returnAddressform={returnAddressform}
          returnFormData={returnFormData}
          setReturnFormData={(e) => {
            setReturnFormData(e);
            setCheckReturnAdded(true);
          }}
          returnPinCodeServiceableStatus={returnPinCodeServiceableStatus}
          getReturnDeliveryPincode={getReturnDeliveryPincode}
          openReturn={returnAddressDrawer}
          setReturnOpen={(e) => setReturnAddressDrawer(e)}
        /> */}

        <div style={{ padding: "2px 14px" }}>
          {/* <Heading title={"Retail Booking"} /> */}
          <div className="d-flex" style={{ alignItems: "center" }}>
            <Heading
              title={"Retail Booking"}
              custom={true}
              navigateTo={"/viewBooking"}
            />
            <div style={{ width: "40%" }}></div>
            {enableDiscount && (
              <div style={{ marginLeft: "3rem", marginBottom: "4px" }}>
                <Button
                  // loading={loading}
                  onClick={
                    () =>
                      navigate("/viewBooking", {
                        state: { currentTab: "4" },
                      })
                    // resetCallBack()
                  }
                  className="btn-style cancel-btn ml-1"
                  style={{ minWidth: "22%" }}
                  onFocus={applyFocusEffect}
                  onBlur={removeFocusEffect}
                >
                  View Discount Bookings
                </Button>
              </div>
            )}
          </div>
          <Row
            className="new-retail-tab-container"
            style={{ background: "white" }}
          >
            <Col xl={16} lg={18} md={18} style={{ padding: "8px 25px" }}>
              <Form
                form={retailNewForm}
                onFinish={onSubmitFormData}
                onValuesChange={(e, b) => handleFormValueChange(e, b)}
                layout="vertical"
                className="global-form"
                scrollToFirstError={{
                  behavior: "smooth",
                  block: "center",
                  inline: "center",
                }}
                onFinishFailed={({ errorFields }) => {
                  if (errorFields?.length > 0) {
                    const firstErrorField = errorFields[0]?.name?.[0];
                    const firstElement =
                      document.getElementById(firstErrorField);
                    if (firstElement) {
                      firstElement.focus();
                    }
                  }
                }}
              >
                {/* <Button onClick={resetCallBack}>RESET</Button> */}

                <NewRetailForm
                  // Loading & Callback Functions
                  editAwb={id}
                  enableForm={history?.state?.type === "discount"}
                  checkGST={checkGST}
                  checkGSTStatus={checkGSTStatus}
                  setdocLoading={setdocLoading}
                  retailLoading={loading}
                  ewayDrawercallBack={(e) => setEwayDrawer(e)}
                  childDrawerCallBack={() => setChildDrawer(true)}
                  eWayBillHandle={eWayBillHandle}
                  // Form and Validation
                  form={retailNewForm}
                  docValidate={docValidate}
                  setDocValidate={setDocValidate}
                  documentValidate={documentValidate}
                  resetForm={resetForm}
                  setMainEwayValidationStatus={setMainEwayValidationStatus}
                  mainEwayValidationStatus={mainEwayValidationStatus}
                  // Freight and Packet Changes
                  onFreightChange={onFreightChange}
                  onPacketChange={onPacketChange}
                  // Options and Configurations
                  insuredOptions={insuredOptions}
                  travelByOptions={travelByOptions}
                  servicesOptions={servicesOptions}
                  pinCodeServiceableStatus={pinCodeServiceableStatus}
                  contentDiscriptionData={contentDiscriptionData}
                  setServiceOptions={setServiceOptions}
                  // Eway Bills & Child Shipments
                  allEwayBills={allEwayBills}
                  setAllEwayBills={setAllEwayBills}
                  childShipments={childShipments}
                  setChildShipments={setChildShipments}
                  // Reviver & Address Details
                  reviverNameAndAddress={reviverNameAndAddress}
                  // getRecvNameAddressList={getRecvNameAddressList}
                  setPinCodeServiceableStatus={setPinCodeServiceableStatus}
                  getDeliveryPincode={getDeliveryPincode}
                  getContentDiscriptionData={getContentDiscriptionData}
                  // Travel and Rate Card
                  mainBaseCharge={mainBaseCharge}
                  getRateCard={getRateCard}
                  // Miscellaneous
                  loading={loading}
                  handleOnEnter={handleOnEnter}
                  getSenderPincode={getSenderPincode}
                  senderPinCodeServiceableStatus={
                    senderPinCodeServiceableStatus
                  }
                  isNonDox={isNonDox}
                  setIsNonDox={setIsNonDox}
                  setSenderPinCodeServiceableStatus={
                    setSenderPinCodeServiceableStatus
                  }
                  applyFocusEffect={applyFocusEffect}
                  removeFocusEffect={removeFocusEffect}
                  isODAIncluded={isODAIncluded}
                  pincodeLoading={pincodeLoading}
                  enableDiscount={enableDiscount}
                />

                <Row
                  align="middle"
                  justify="space-between"
                  style={{ width: "100%" }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <div style={{ width: "20%", marginRight: "8px" }}>
                      <Form.Item
                        label="Upload document"
                        name="docType"
                        rules={[
                          {
                            required: false,
                            message: "Select type",
                          },
                        ]}
                      >
                        <Select
                          showAction={["focus", "click"]}
                          allowClear
                          showSearch
                          filterOption={(input, option) =>
                            (option?.label ?? "")
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          // onKeyDown={(event) =>
                          //   handleKeyDown(event, payOptions, "paymentMode", "value")
                          // }
                          // onKeyPress={(event) => {
                          //   if (event.key == "Enter") {
                          //     handleOnEnter(event);
                          //   }
                          // }}
                          onClear={() => setDocAdded(null)}
                          onSelect={(e) => setDocAdded(e)}
                          className="pincodeType-placecholder"
                          placeholder="Select type"
                          options={docOptions}
                        />
                      </Form.Item>
                    </div>

                    <div style={{ marginLeft: "auto" }}>
                      <Button
                        htmlType="submit"
                        id="submit_credit"
                        // loading={loading}
                        disabled={loading || docLoading || pincodeLoading}
                        className="btn-style cancel-btn ml-1"
                        style={{ minWidth: "22%" }}
                        onKeyDown={(event) => {
                          if (event.key === "Tab") {
                            // handleOnEnter(event, "documentNumber");
                            event.preventDefault();

                            if (debounceTimeout.current) {
                              clearTimeout(debounceTimeout.current);
                            }

                            debounceTimeout.current = setTimeout(() => {
                              retailNewForm.submit();
                            }, 300);
                            window.scrollTo(0, 0);
                          } else if (event.key === "Enter") {
                            event.preventDefault();

                            if (debounceTimeout.current) {
                              clearTimeout(debounceTimeout.current);
                            }

                            debounceTimeout.current = setTimeout(() => {
                              retailNewForm.submit();
                            }, 300);
                          }
                        }}
                        onFocus={applyFocusEffect}
                        onBlur={removeFocusEffect}
                      >
                        {id ? "UPDATE BOOKING" : "CONFIRM BOOKING"}
                      </Button>
                    </div>
                  </div>
                </Row>
                <Row>
                  {docAdded || fileList?.length ? (
                    <UploadDocument
                      docAdded={docAdded}
                      setFileList={setFileList}
                      fileList={fileList}
                    />
                  ) : null}
                </Row>
              </Form>
              <Row style={{ paddingBottom: "12px" }}>
                <Col lg={24} sm={24} md={24}>
                  <div>
                    <RecentBooking
                      bookingType="Cash"
                      recentBookingsData={recentBookingsData}
                      handleRecentBookingsData={handleRecentBookingsData}
                    />
                  </div>
                </Col>
              </Row>
            </Col>
            <Col xl={8} lg={6} md={6} className="new-retail-card-container">
              <div className="pt-1">
                {/* <AddressCard
                  iconStyles={iconStyles}
                  setReturnCheck={setReturnCheck}
                  returnCheck={returnCheck}
                  checkReturnAdded={checkReturnAdded}
                  setReturnAddressDrawer={setReturnAddressDrawer}
                  addresCardStyles={addresCardStyles}
                  capitalize={capitalize}
                  retailNewForm={retailNewForm}
                  handleReturnCheckBox={handleReturnCheckBox}
                  returnFormData={returnFormData}
                  disable={id}
                /> */}
              </div>

              {!id || editShipmentDetails?.items?.isDiscountBooking ? (
                <>
                  <div>
                    <Card
                      size="small"
                      className="dashboard-container-card-div"
                      title={
                        <div>
                          <span className="announcement-text">
                            {" "}
                            Booking Summary
                          </span>
                        </div>
                      }
                      style={{
                        ...addresCardStyles,
                      }}
                    >
                      <SummaryComponent
                        summaryData={summaryData}
                        docType={retailNewForm.getFieldValue("shipmentType")}
                        isODAIncluded={isODAIncluded}
                      />
                    </Card>
                  </div>
                </>
              ) : null}
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default NewRetailUX;
